import React, { useEffect } from 'react'

import homepageContentSource from '../../content/homepage.json'
import mapContentSource from '../../content/map.json'
import { pushToGTM } from '../../shared/utis/gtm'
import AnnouncementBar from './components/AnnouncementBar/AnnouncementBar'
import CoreServices from './components/CoreServices/CoreServices'
import DataEnabledInvestigations from './components/DataEnabledInvestigations/DataEnabledInvestigations'
import FeaturedCaseStudy from './components/FeaturedCaseStudy/FeaturedCaseStudy'
import FeaturedOn from './components/FeaturedOn/FeaturedOn'
import Footer from './components/Footer/Footer'
import HPForm from './components/HP-Form/Form'
import HomeHero from './components/HomeHero/HomeHero'
import HomeNavigation from './components/HomeNavigation/HomeNavigation'
import InFocus from './components/InFocus/InFocus'
import Intelligence from './components/Intelligence/Intelligence'
import Map from './components/Map/Map'
import MapBoundary from './components/MapBoundary/MapBoundary'
import Partners from './components/Partners/Partners'
import ReportDownloadModal from './components/ReportDownloadModal/ReportDownloadModal'
import TypicalSituations from './components/TypicalSituations/TypicalSituations'
import styles from './styles.module.scss'
import { type HomepageContent } from './types'
import {
  DEFAULT_CONTACT_FORM,
  DEFAULT_HOMEPAGE_LABELS,
  DEFAULT_NAVIGATION,
  withLabelDefaults,
} from './utils/labels'
import { type CmsMapContent, normalizeMapContent } from './utils/mapContent'

const homepageContent = homepageContentSource as HomepageContent
const mapContent = normalizeMapContent(mapContentSource as CmsMapContent)
const labels = withLabelDefaults(DEFAULT_HOMEPAGE_LABELS, homepageContent.labels)
const navigation = homepageContent.navigation?.filter((item) => item.label && item.url).length
  ? homepageContent.navigation.filter((item) => item.label && item.url)
  : DEFAULT_NAVIGATION
const contactFormCopy = withLabelDefaults(DEFAULT_CONTACT_FORM, homepageContent.contactForm)

const Home = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    })
  }, [])

  return (
    <div className={styles.page}>
      <AnnouncementBar announcement={homepageContent.announcement} />
      <HomeNavigation items={navigation} />
      <main>
        <HomeHero hero={homepageContent.hero} />
        <CoreServices content={homepageContent.coreServices} />
        <Intelligence content={homepageContent.intelligence} />
        <FeaturedOn
          title={labels.featuredOnTitle}
          logos={homepageContent.featuredOn}
          marqueeEnabled={homepageContent.featuredOnMarqueeEnabled !== false}
        />
        <DataEnabledInvestigations content={homepageContent.dataEnabledInvestigations} />
        <TypicalSituations content={homepageContent.typicalSituations} />
        <FeaturedCaseStudy eyebrow={labels.caseStudyEyebrow} ctaLabel={labels.caseStudyCta} />
        <Partners title={labels.partnersTitle} partners={homepageContent.partners} />
        <MapBoundary>
          <Map content={mapContent} />
        </MapBoundary>
        <InFocus title={labels.inFocusTitle} ctaLabel={labels.inFocusCta} />
        <section id="contact">
          <HPForm
            copy={contactFormCopy}
            afterSubmit={() => {
              pushToGTM({
                event: 'contact_form_submit',
                tagName: 'Contact form submission “Contact our team today” (homepage)',
              })
            }}
          />
        </section>
      </main>
      <Footer />
      <ReportDownloadModal />
    </div>
  )
}
export default Home
